/* eslint-disable react-hooks/exhaustive-deps */
import { useState,useEffect,useContext } from "react";
import PerformanceEvaluationContext from "../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { createPerformanceEvaluationModal } from "../../context/PerformanceEvaluationContext/Actions";
import  {IPerformanceEvaluation} from'../../interfaces/PerformanceEvaluation.interface'
import { useQuery  } from "@apollo/client";
import {GET_ALL_PERFORMANCES_EVALUATION } from "../../Querys/performanceEvaluation/querys";
import BtnCreate from "./Components/BtnCreate";
import FiltroEstadosPerformanceEvaluation from './Components/FiltroEstadosPerformanceEvaluation';
import SearcherCardPerformanceEv from "./Components/SearcherCardPerformanceEv";
import PerformanceEvaluationCard from "./Components/PerformanceEvaluationCard";
import ModalPerformanceEvaluation from "./modals/ModalPerformanceEvaluation";
import CollaboratorsPerformanceEvaluation from "./modals/CollaboratorsPerformanceEvaluation"
import EliminaPerformanceEvaluation from "./modals/EliminaPerformanceEvaluation";
import Box from '@mui/material/Box';
import { Grid } from "@material-ui/core";
import CheckPermission from "../../helpers/Administradores/Permissions";
import "./css/PerformanceEvaluation.css"

const PerformanceEvaluation = () => {
  const {state,dispatch} = useContext(PerformanceEvaluationContext);  
  const [filtroEstado, setFiltroEstado] = useState('definicion')
  const [performanceEvalInit, setPerformanceEvalInit] = useState<IPerformanceEvaluation[]>([]);
  const [performanceEval, setPerformanceEval] = useState<IPerformanceEvaluation[]>([]);
  const [performanceEvalFilter, setPerformanceEvalFilter] = useState<IPerformanceEvaluation[]>([]);
  const [stepFilter, setStepFilter] = useState<IPerformanceEvaluation[]>([])
  const [stepPerformanceEvalFilter, setStepPerformanceEvalFilter] = useState<IPerformanceEvaluation[]>([])
    const { data: resultPerformanceEval,loading,startPolling, stopPolling } = useQuery(GET_ALL_PERFORMANCES_EVALUATION);
  const allPerformanceEval = resultPerformanceEval?.GET_ALL_PERFORMANCES_EVALUATION;  

  const openModaleCreate=()=>{
     createPerformanceEvaluationModal("0",null,true, dispatch)
  }

  useEffect(()=>{
    startPolling(5000);
    return () =>{
        stopPolling()
    }
},[startPolling,stopPolling])

  useEffect(() => { 
    if (allPerformanceEval){
           const copyAllPerformanceEval=[...allPerformanceEval]
      let newAllPerformanceEval = copyAllPerformanceEval.sort((x, y) => y.id - x.id);  
      setPerformanceEvalInit(newAllPerformanceEval)
      setPerformanceEval(newAllPerformanceEval)
      setPerformanceEvalFilter(newAllPerformanceEval)
      setStepFilter(newAllPerformanceEval)
      setStepPerformanceEvalFilter(newAllPerformanceEval)
     } }, [allPerformanceEval]);


  const cambioStep = () => {
    let registros = (resultPerformanceEval?.GET_ALL_PERFORMANCES_EVALUATION.filter((e: any) => e.step === filtroEstado))   
    if(registros && registros.length>0){
      registros=  registros.sort(function(a:any, b:any) {
         return b.id-a.id 
       });    
     setStepFilter(registros)
     setStepPerformanceEvalFilter(registros)        
     }
   else{
     setStepFilter(registros)
     setStepPerformanceEvalFilter(registros)      
    }
   }

   useEffect(() => {
    cambioStep() 
  }, [filtroEstado])

  useEffect(() => {
    if (performanceEvalFilter.length > 0) {
      const orderFilter = [...performanceEvalFilter]
      orderFilter.sort((a: any, b: any) => { return (a.id - b.id) })
      setPerformanceEval(orderFilter);
      cambioStep() 
     }   
  }, [performanceEvalFilter]);


  return (
    <>  
      <div className="c_contenedorTitulo">
        <div className="c_contenedorProceso">
          <FiltroEstadosPerformanceEvaluation 
              filtroEstado={filtroEstado} 
              setFiltroEstado={setFiltroEstado} />
        </div>
         {CheckPermission("EvalDesempenio.Evaluaciones.Crear") && ( 
            <Box>
               <BtnCreate 
                txtBtn="Crear nueva evaluación" 
                openModal={openModaleCreate}
                />
           </Box>
         )}        
      </div>

      {(loading === true) ?
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
        :
      
        <div className="c_contenedorPrincipal">
          <Grid container className="screenBtns">
            <Grid className="findCampaign">
               <SearcherCardPerformanceEv
                initState={performanceEval}
                setState={setPerformanceEvalFilter}
                stateInitial={performanceEvalInit}
                setStepFilter={setStepFilter}
                stepPerformanceEvalFilter={stepPerformanceEvalFilter}
                filtroEstado={filtroEstado} 
                label={"Buscar evaluación"}
                fields={['Nombre de la evaluación']}
                width={400}
              />
            </Grid>
     
          </Grid>          
          <Grid container className="cardsCampaign" >           
           <Grid container spacing={2}>
              {
                stepFilter?.length > 0 ?
                stepFilter?.map((perfomance: any) => {
                    return (
                      <Grid item key={perfomance.id}>
                        <PerformanceEvaluationCard
                          performanceEval={perfomance}
                        />
                      </Grid>
                    )
                  }) :
                  performanceEval?.length > 0 ?
                    <div className="contenedorMensajeCarga">
                    <div className="mensajeCarga"> Por el momento no existen evaluaciones con este estatus</div>
                    </div>            
                    :
                    <div className="contenedorMensajeCarga">
                      <div className="mensajeCarga"> Comienza a crear evaluaciones de desempeño</div>
                    </div>
              }
            </Grid>
          </Grid>         
        </div>        
      } 
      <ModalPerformanceEvaluation /> 
      <EliminaPerformanceEvaluation/>
      {state._id !=='' &&(
        <>
      <CollaboratorsPerformanceEvaluation />           
      </>
      )
      }    
      </>   
  )
}

export default PerformanceEvaluation